import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the table view for agent list.
 * @extends JetView
 */
export default class tableAgentListView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance

        /**
         * Custom checkbox template for action column.
         * @param {Object} obj - The data object for the row.
         * @param {Object} common - Common properties.
         * @param {string} value - The value of the checkbox.
         * @returns {string} The HTML string for the checkbox.
         */
        function custom_checkbox(obj, common, value) {
            if (value != 'I')
                return ''; // Return empty if not 'I'
            else
                return '<div style=" padding: 0px 14px;display: inline-block;background: green;color: #fff;font-size: 13px; " class=\'webix_table_checkbox webixbutton approbarbutton\'>A</div><div style=" padding: 0px 14px;display: inline-block;background: red;color: #fff;font-size: 13px;" class=\'webix_table_checkbox webixbutton rechazarbutton\'> N </div>'; // Return action buttons
        }

        return {
            rows: [
                {
                    cols: [
                        {
                            view: 'datatable', // Data table view
                            id: 'datatable', // Unique identifier for the datatable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            scrollY: window.orientation === 90 ? true : false, // Enable vertical scrolling based on orientation
                            columns: [
                                {
                                    id: 'Action', // Column ID
                                    header: '', // Column header
                                    width: 100, // Column width
                                    height: 25, // Column height
                                    tooltip: 'Acción', // Tooltip text
                                    template: function (obj) {
                                        // Template function for rendering
                                        if (obj.IsRegisterActivate != 'I')
                                            // Check if the register is not active
                                            return '';
                                        else
                                            return '<div style=" padding: 0px 14px;display: inline-block;background: green;color: #fff;font-size: 13px; " class=\'webix_table_checkbox webixbutton approbarbutton\'>A</div><div style=" padding: 0px 14px;display: inline-block;background: red;color: #fff;font-size: 13px;" class=\'webix_table_checkbox webixbutton rechazarbutton\'> N </div>'; // Return action buttons
                                    },
                                },
                                {
                                    id: 'detailTittle', // Column ID
                                    header: '', // Column header
                                    width: 50, // Column width
                                    height: 25, // Column height
                                    tooltip: _('Detalles'), // Tooltip text
                                    template: function (obj) {
                                        // Template function for rendering
                                        return "<span class='webix_icon wxi-close details'></span>"; // Return details icon
                                    },
                                },
                                {
                                    id: 'Id', // Column ID
                                    header: _('ID Usuario'), // Column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'FirstName', // Column ID
                                    header: _('Nombre'), // Column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'MobilePhone', // Column ID
                                    header: _('Teléfono'), // Column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Login', // Column ID
                                    header: _('Usuario (Correo electrónico)'), // Column header
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'DocNumber', // Column ID
                                    header: _('DNI'), // Column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'CreatedLocalDate', // Column ID
                                    header: _('Fecha de Creación'), // Column header
                                    fillspace: 0, // Fill space option
                                    minWidth: 0, // Minimum width
                                    width: 150, // Column width
                                    sort: 'text', // Sorting type
                                    format: dateFormat, // Date formatting
                                },
                                {
                                    id: 'Ip', // Column ID
                                    header: 'Ip', // Column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                            ],
                            onClick: {
                                /**
                                 * Event handler for clicking the details icon.
                                 * @param {Object} euv - Event object.
                                 * @param {string} id - ID of the clicked item.
                                 */
                                details: function (euv, id) {
                                    if (vthis.getUrl()[0].page !== 'customers')
                                        // Check current page
                                        vthis.show(
                                            'customers?user=' + id + '/information', // Show user information
                                        );
                                    else vthis.show('information'); // Show general information
                                },
                                /**
                                 * Event handler for clicking the approve button.
                                 * @param {Object} ev - Event object.
                                 * @param {string} id - ID of the clicked item.
                                 */
                                approbarbutton: function (ev, id) {
                                    var item = this.getItem(id); // Get the item by ID
                                    if (item.IsRegisterActivate == 'I') {
                                        // Check if the register is inactive
                                        webix.confirm({
                                            type: 'confirm-warning', // Confirmation type
                                            text: _('Advertencia!') + '<br/>' + _('Desea activar registro?'), // Confirmation message
                                            ok: _('Activar registro'), // OK button text
                                            cancel: _('Salir'), // Cancel button text
                                            callback: function (action) {
                                                if (action === true) {
                                                    // If confirmed
                                                    const data = {
                                                        Id: item.Id, // Prepare data for API call
                                                        Action: 'A', // Action to activate
                                                    };
                                                    webix
                                                        .ajax()
                                                        .headers({
                                                            'Content-type': 'application/json', // Set content type
                                                        })
                                                        .post(
                                                            devConfig.geturlApi() + 'Client/ActivateClient', // API endpoint
                                                            data, // Data to send
                                                            {
                                                                error: function (text, data, XmlHttpRequest) {
                                                                    webix.message(
                                                                        'Error', // Error message
                                                                    );
                                                                },
                                                                success: function (text, data, XmlHttpRequest) {
                                                                    var json = JSON.parse(
                                                                        text, // Parse response
                                                                    );
                                                                    if (
                                                                        json.HasError // Check for errors in response
                                                                    ) {
                                                                        webix.message({
                                                                            title: '¡Error!', // Error title
                                                                            type: 'alert-error', // Error type
                                                                            text: _(
                                                                                'Ocurrio un error, comuniquese con soporte', // Error message
                                                                            ),
                                                                        });
                                                                    } else {
                                                                        item.IsRegisterActivate = 'A'; // Update item status
                                                                        item.Action = 'A'; // Update action
                                                                        webix.message(
                                                                            'Saved', // Success message
                                                                        );
                                                                        $$('datatable').refresh(); // Refresh datatable
                                                                    }
                                                                },
                                                            },
                                                        );
                                                }
                                            },
                                        });
                                    } else {
                                        webix.message({
                                            title: '¡Error!', // Error title
                                            type: 'alert-error', // Error type
                                            text: _(
                                                'No puedes activar un registro ya actualizado.', // Error message
                                            ),
                                        });
                                    }
                                },
                                /**
                                 * Event handler for clicking the reject button.
                                 * @param {Object} ev - Event object.
                                 * @param {string} id - ID of the clicked item.
                                 */
                                rechazarbutton: function (ev, id) {
                                    var item = this.getItem(id); // Get the item by ID
                                    if (item.IsRegisterActivate == 'I') {
                                        // Check if the register is inactive
                                        webix.confirm({
                                            type: 'confirm-warning', // Confirmation type
                                            text: _('Advertencia!') + '<br/>' + _('Desea rechazar registro?'), // Confirmation message
                                            ok: _('Rechazar registro'), // OK button text
                                            cancel: _('Salir'), // Cancel button text
                                            callback: function (action) {
                                                if (action === true) {
                                                    // If confirmed
                                                    const data = {
                                                        Id: item.Id, // Prepare data for API call
                                                        Action: 'R', // Action to reject
                                                    };
                                                    webix
                                                        .ajax()
                                                        .headers({
                                                            'Content-type': 'application/json', // Set content type
                                                        })
                                                        .post(
                                                            devConfig.geturlApi() + 'Client/RejectClient', // API endpoint
                                                            data, // Data to send
                                                            {
                                                                error: function (text, data, XmlHttpRequest) {
                                                                    webix.message(
                                                                        'Error', // Error message
                                                                    );
                                                                },
                                                                success: function (text, data, XmlHttpRequest) {
                                                                    var json = JSON.parse(
                                                                        text, // Parse response
                                                                    );
                                                                    if (
                                                                        json.HasError // Check for errors in response
                                                                    ) {
                                                                        webix.message({
                                                                            title: _(
                                                                                '¡Error!', // Error title
                                                                            ),
                                                                            type: 'alert-error', // Error type
                                                                            text: _(
                                                                                'Ocurrio un error, comuniquese con soporte', // Error message
                                                                            ),
                                                                        });
                                                                    } else {
                                                                        item.IsRegisterActivate = 'R'; // Update item status
                                                                        item.Action = 'R'; // Update action
                                                                        $$('datatable').refresh(); // Refresh datatable
                                                                        webix.message(
                                                                            'Saved', // Success message
                                                                        );
                                                                    }
                                                                },
                                                            },
                                                        );
                                                }
                                            },
                                        });
                                    } else {
                                        webix.message({
                                            title: '¡Error!', // Error title
                                            type: 'alert-error', // Error type
                                            text: _(
                                                'No puedes activar un registro ya actualizado.', // Error message
                                            ),
                                        });
                                    }
                                },
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            pager: 'pagerA', // Pager ID
                            url: devConfig.geturlApi() + 'es/Client/GetClients2', // Data source URL
                            on: {
                                /**
                                 * Event handler for double-clicking an item.
                                 * @param {string} id - ID of the double-clicked item.
                                 */
                                onItemDblClick: (id) => {
                                    if (this.getUrl()[0].page !== 'customers')
                                        // Check current page
                                        this.show(
                                            'customers?user=' + id + '/information', // Show user information
                                        );
                                    else this.show('information'); // Show general information
                                },
                                /**
                                 * Event handler before loading data.
                                 */
                                onBeforeLoad: function () {
                                    this.showOverlay(
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>", // Show loading overlay
                                    );
                                },
                                /**
                                 * Event handler after loading data.
                                 */
                                onAfterLoad: function () {
                                    this.hideOverlay(); // Hide loading overlay
                                },
                            },
                            ready: function () {
                                if (!this.count()) {
                                    // Check if there are no items
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay box
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') + // Show no data message
                                            '</div>',
                                    );
                                }
                            },
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        console.log(window.orientation); // Log the current window orientation
        grid = $$('datatable'); // Get the datatable instance
        var url = grid.data.url; // Store the data URL
        var filter = ''; // Initialize filter string

        // Event listener for filtering data
        this.on(this.app, 'playersList:filter', (filterData) => {
            console.log('filterData ', filterData); // Log filter data
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string

            // Loop through filter data entries
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object values
                    if (object[i][0] == 'Datepicker') {
                        // Check for datepicker filter
                        if (object[i][1] !== ' ') {
                            var date = object[i][1].split(' - '); // Split date range
                            console.log(date);
                            string1 = string1 + '&dateFrom=' + date[0]; // Add start date to query
                            string1 = string1 + '&dateTo=' + date[1]; // Add end date to query
                        }
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Check for object values
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Check for start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format start date
                                    string1 = string1 + '&' + dateFrom; // Add start date to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Check for end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format end date
                                        string1 = string1 + '&' + dateTo; // Add end date to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
            filter = string1; // Update filter string
        });

        // Event listener for sorting data
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });

        // Event listener for item click
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get the clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        // Event listener before editing starts
        grid.attachEvent('onBeforeEditStart', function (id) {
            var item = this.getItem(id); // Get the item being edited
            console.log(item);
            if (id.column == 'Action') {
                // Check if editing the Action column
                var options = this.getColumnConfig('Action').collection; // Get column options
                if (item.IsRegisterActivate != 'I') {
                    // Check if the register is not inactive
                    console.log(item);
                    return false; // Prevent editing
                }
                console.log(id);
            }
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data for selected player
            );
        });
    }
}

// FILE DOCUMENTED
